import { SvgIcon } from '@mui/material';
import { ReactNode } from 'react';
import { StyledNavigationButton } from '../styles';

type Props = {
  onClick: () => void;
  icon: ReactNode;
  top?: string;
  left?: string;
  right?: string;
  bottom?: string;
  size?: 'md' | 'lg';
  isRounded?: boolean;
  'data-treedistestid'?: string;
};

export default function ControlBtn({
  onClick,
  icon,
  top,
  left,
  right,
  bottom,
  size = 'md',
  isRounded,
  'data-treedistestid': testId,
}: Props) {
  const isLg = size === 'lg';
  return (
    <StyledNavigationButton
      onClick={onClick}
      data-treedistestid={testId}
      sx={{
        top,
        left,
        right,
        bottom,
        width: { xs: isLg ? '40px' : '30px', sm: isLg ? '48px' : '40px' },
        height: { xs: isLg ? '40px' : '30px', sm: isLg ? '48px' : '40px' },

        ...(!isRounded && {
          borderRadius: '8px',

          '& .MuiTouchRipple-root .MuiTouchRipple-child': {
            borderRadius: '8px',
          },
        }),
      }}
    >
      <SvgIcon>{icon}</SvgIcon>
    </StyledNavigationButton>
  );
}
